<mat-card class="detail-card" valumizeCardContextMenu context="/deals/overview/">
  @let params = params$ | async;
  <mat-card-header class="detail-card-header">
    <mat-card-title data-test="title">Deal Overview</mat-card-title>
  </mat-card-header>
  @if (reportGenerationStatus$ | async; as reportGenerationStatus) {
    <mat-card-subtitle>
      @if (reportGenerationStatus.status === 'ERROR') {
        <valumize-info-panel [appearance]="'SAVED'" [message]="reportGenerationStatus.errorMessage"></valumize-info-panel>
      }
    </mat-card-subtitle>
  }
  <mat-card-content class="detail-card-content">
    <div class="table-toolbar">
      @if (params) {
        <mat-checkbox color="primary" [checked]="params.archived" (change)="onArchivedChanged(!params.archived)">
          Show Archived
        </mat-checkbox>
      }
      <span class="spacer"></span>
      @if (selectMode) {
        <span class="bulk-action-count">{{ selection.selected.length }} selected</span>
        @if (params?.archived) {
          <button mat-stroked-button (click)="archiveSelected(false)">
            <mat-icon>unarchive</mat-icon>
            Unarchive
          </button>
        } @else {
          <button mat-stroked-button color="primary" (click)="archiveSelected(true)">
            <mat-icon>archive</mat-icon>
            Archive
          </button>
        }
        @if (canDelete) {
          <button mat-stroked-button color="warn" (click)="deleteSelected()">
            <mat-icon>delete</mat-icon>
            Delete
          </button>
        }
        <button mat-button (click)="exitSelectMode()">Clear</button>
      }
      @if (searchVisible) {
        <input matInput #searchInput id="search-input" class="list-search-input" (input)="onSearchInput($event)" placeholder="Search">
      }
      <valumize-card-comments-button context="/deals/overview/"></valumize-card-comments-button>
      <button mat-icon-button (click)="toggleSearch()" matTooltip="Search">
        <mat-icon>search</mat-icon>
      </button>
      <button mat-icon-button (click)="openTableSettings()" matTooltip="Table Settings">
        <mat-icon>view_column</mat-icon>
      </button>
    </div>

    <div class="table-container">
      @if (isLoading$ | async) {
        <div class="loading-overlay">
          <mat-spinner diameter="40"></mat-spinner>
        </div>
      }

      <table mat-table [dataSource]="(deals$ | async) ?? []" matSort (matSortChange)="onSortChange($event)" [matSortActive]="sortActive" [matSortDirection]="sortDirection">
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element" (click)="$event.stopPropagation()">
            <mat-checkbox color="primary"
                          (change)="selection.toggle(element)"
                          [checked]="selection.isSelected(element)">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="dealId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="id">ID</th>
          <td mat-cell *matCellDef="let element">{{element.id}}</td>
        </ng-container>

        <ng-container matColumnDef="dealName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="projectName">Deal</th>
          <td mat-cell *matCellDef="let element">
            @if (element.isArchived?.value) {
              <mat-icon class="archived-icon">inventory_2</mat-icon>
            }
            {{element.projectName | traceableFormat}}
          </td>
        </ng-container>

        <ng-container matColumnDef="closingDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="closingDate">Closing Date</th>
          <td mat-cell *matCellDef="let element">{{element.closingDate | traceableFormat}}</td>
        </ng-container>

        <ng-container matColumnDef="currencyIso">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="currencyIso">Currency</th>
          <td mat-cell *matCellDef="let element">{{ element.currencyIso.code | codeFormat: codeTableCurrency | async }}</td>
        </ng-container>

        <ng-container matColumnDef="totalDealSize">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="totalDealSize">Total Deal Size</th>
          <td mat-cell *matCellDef="let element">{{element.totalDealSize | traceableFormat}}</td>
        </ng-container>

        <ng-container matColumnDef="totalNav">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="totalNav">Total NAV</th>
          <td mat-cell *matCellDef="let element">{{element.totalNav | traceableFormat}}</td>
        </ng-container>

        <ng-container matColumnDef="bidPrice">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="bidPrice">Bid Price</th>
          <td mat-cell *matCellDef="let element">{{element.bidPrice | traceableFormat}}</td>
        </ng-container>

        <ng-container matColumnDef="discountToNav">
          <th mat-header-cell *matHeaderCellDef mat-sort-header="discountToNav">Discount to NAV</th>
          <td mat-cell *matCellDef="let element">{{element.discountToNav | traceableFormat}}</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row
          *matRowDef="let row; columns: displayedColumns"
          [routerLink]="selectMode ? null : row.id"
          (contextmenu)="onRowContextMenu($event, row)"></tr>
      </table>
    </div>

    <valumize-context-menu #ctxMenu></valumize-context-menu>

    @if (params) {
      <mat-paginator
        [length]="(totalElements$ | async) ?? 0"
        [pageIndex]="params.page"
        [pageSize]="params.size"
        [pageSizeOptions]="[10, 20, 30, 50, 100]"
        showFirstLastButtons
        (page)="onPageChange($event)">
      </mat-paginator>
    }

    <valumize-previous-reports></valumize-previous-reports>
  </mat-card-content>
  <mat-card-actions class="overview-actions">
    <button mat-stroked-button color="primary" (click)="openProjectReportDialog()" data-test="generate-report">
      <mat-icon>insert_drive_file</mat-icon>
      Report
    </button>
    <button mat-stroked-button color="primary" (click)="openNewDealDialog()" data-test="new-deal">
      <mat-icon>add</mat-icon>
      Deal
    </button>
  </mat-card-actions>
</mat-card>
